module.exports = __webpack_public_path__ + "img/mada.5d80b702.svg";